import { createSlice } from '@reduxjs/toolkit';
import { getTestimonials, getTestimonialsById } from './actions';

const initialState = {
  list: [],
  byId: {},
  byInfluencers: [],
  byCommonUsers: [],
  isLoading: false,
  isError: false,
  errorMessage: {},
};

export const testimonial = createSlice({
  name: 'testimonial',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getTestimonials.pending, (state) => {
        state.isLoading = true;
        state.isError = false;
        state.errorMessage = {};
        state.list = [];
      })
      .addCase(getTestimonials.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.errorMessage = action.payload;
      })
      .addCase(getTestimonials.fulfilled, (state, action) => {
        state.isLoading = false;
        state.list = action.payload;
      })
      .addCase(getTestimonialsById.pending, (state) => {
        state.isLoading = true;
        state.isError = false;
        state.errorMessage = {};
        state.byId = {};
      })
      .addCase(getTestimonialsById.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.errorMessage = action.payload;
      })
      .addCase(getTestimonialsById.fulfilled, (state, action) => {
        state.isLoading = false;
        state.byId = action.payload;
      });
  },
});

export default testimonial.reducer;
